import { NgModule } from '@angular/core';
import { CapPageHeaderComponent } from './cap-page-header.component';

@NgModule({
  declarations: [CapPageHeaderComponent],
  imports: [
  ],
  exports: [CapPageHeaderComponent]
})
export class CapPageHeaderModule { }
